import React from 'react';

export const Skeleton = ({ className = '' }) => {
  return (
    <div className={`animate-pulse bg-[#27272A]/70 rounded-xl ${className}`} />
  );
};

export const SkeletonCard = () => {
  return (
    <div className="bg-[#121215] border border-[#27272A] rounded-2xl p-5 shadow-card space-y-3 animate-pulse">
      <div className="flex items-center justify-between">
        <Skeleton className="h-3 w-24" />
        <Skeleton className="h-5 w-5 rounded-lg" />
      </div>
      <Skeleton className="h-8 w-32" />
      <Skeleton className="h-4 w-20 rounded-full" />
    </div>
  );
};

export const SkeletonTable = ({ rows = 4, cols = 5 }) => {
  return (
    <div className="space-y-3 animate-pulse">
      <div className="h-8 bg-[#1A1A1E] rounded-xl w-full mb-4" />
      {Array.from({ length: rows }).map((_, rIdx) => (
        <div key={rIdx} className="flex items-center justify-between space-x-4 p-3 bg-[#09090B] rounded-xl border border-[#27272A]/50">
          {Array.from({ length: cols }).map((_, cIdx) => (
            <Skeleton key={cIdx} className={`h-4 ${cIdx === 0 ? 'w-28' : 'w-16'}`} />
          ))}
        </div>
      ))}
    </div>
  );
};

export const Spinner = ({ size = 'md', className = '' }) => {
  const sizeClasses = {
    sm: 'w-4 h-4 border-2',
    md: 'w-6 h-6 border-2',
    lg: 'w-10 h-10 border-3',
  };
  return (
    <div className={`border-[#F97316] border-t-transparent rounded-full animate-spin ${sizeClasses[size] || sizeClasses.md} ${className}`} />
  );
};

export default Skeleton;
